import { createContext } from "react";
export default createContext({
  theme: {},
  global: true
});